import { getMoney } from '../../common/functions/helpers';

export default {
  data() {
    return {
      indexPagina: 0,
    };
  },
  props: {
    registros: {
      type: Array,
      default: [],
    },
    paginas: Number,
    title: {
      type: String,
      default: '',
    },
    limitePagina: {
      type: Number,
      default: 5,
    },
    carregando: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    possuiRegistros() {
      return !!this.registros && !!this.registros.length;
    },
  },
  methods: {
    getMoney,
    clickHandler(pagina) {
      this.indexPagina = pagina - 1;
      this.$emit('TABELA_BUSCAR_PROXIMA_PAGINA', pagina);
    },
    refazPaginacao() {
      this.indexPagina = 0;
    },
    formatPercent(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'percent' });
    },
    formatDecimal(val) {
      return (val || 0).toLocaleString('pt-br', { style: 'decimal' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared-components/generico/tabelaCommonsMixin.js